import { render, staticRenderFns } from "./Health.vue?vue&type=template&id=a96a29e2&"
import script from "./Health.vue?vue&type=script&lang=js&"
export * from "./Health.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports